(ns app.strive-forms.question-fields.phone-number
  (:require ["mui-tel-input" :refer (MuiTelInput , matchIsValidTel)]
            [app.strive-forms.component-multi-methods :refer [calc-error-message
                                                              show-action-btn? update-question-input-data update-question-input-local]]
            [app.strive-forms.defaults :refer [default-values]]
            [app.strive-forms.events :as sfevents]
            [app.strive-forms.helper-functions :refer [check-button-status
                                                       color-condition
                                                       component-alignment get-default-text-val on-focus-toggle set-values-for-button!
                                                       update-preview-panel!]]
            [app.strive-forms.styles :refer [responsive-input-field-border-class responsive-input-field-style
                                             warning-notification]]
            [app.strive-forms.subs :as subs]
            [clojure.string :as s]
            [re-com.core :as re-com :refer [v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core  :as r]))
;TODO: add error messages to form_messages in db later
(defmethod calc-error-message "phone_number" [{:keys [form-messages valid?]}]
  (let [invalid-message (:phone_number (:errors default-values))]
    (if (not @valid?) invalid-message "")))

(defn valid-phone-number? [phone-number]
  (matchIsValidTel phone-number))

(defmethod show-action-btn? "phone_number" [_]
  true)

(defmethod update-question-input-local "phone_number" [{:keys [input-data field-id input-value]}]
  (re-frame/dispatch [::sfevents/update-input-local
                      {:input-data input-data :key (keyword field-id) :value input-value}]))

(defmethod update-question-input-data "phone_number" [{:keys [input-data field-id input-value]}]
  (update input-data (keyword field-id) (fn [value]
                                          (assoc value :value input-value))))

(defn- phone-num-on-change! [{:keys [phone-number phone-valid? phone-num-button-disabled?]}]
  #(do (reset! phone-number %)
       (reset! phone-valid? (valid-phone-number? @phone-number))
       (when @phone-valid? (reset! phone-num-button-disabled? false))))

(defn- phone-number-input-label [{:keys [phone-number default-value country-code phone-valid? on-focus theme-data phone-num-button-disabled?]}]
  [(r/adapt-react-class MuiTelInput)
   {:value (or
            @phone-number
            @default-value)
    :defaultCountry  @country-code
    :on-focus (on-focus-toggle on-focus)
    :on-blur (on-focus-toggle on-focus)
    :onChange (phone-num-on-change! {:phone-number phone-number :phone-valid? phone-valid?
                                     :phone-num-button-disabled? phone-num-button-disabled?})}
   :class (responsive-input-field-border-class {:border-color (color-condition {:valid? @phone-valid?
                                                                                :on-focus @on-focus
                                                                                :theme-data theme-data
                                                                                :default-color (:dark-gray (:themes default-values))})
                                                ;:border-size (str (if @on-focus "2px" "1px") " solid")
                                                :margin (when @on-focus "-1px")
                                                :width "95%"})])

(defn phone-number-field [{:keys [field-id input-data]}]
  (let [phone-valid? (r/atom true)
        phone-num-button-disabled? (r/atom true)
        phone-number (r/atom (:value (get input-data (keyword field-id))))
        form-data  @(re-posh/subscribe [::subs/form-data])
        on-focus (r/atom false)]

    (fn [{:keys [field field-id index input-value theme-data form-messages current-page input-data 
                 default-value is-multi-question? button-ids-for-button]}]
      #_(println (color-condition {:valid? @phone-valid?
                                   :on-focus @on-focus
                                   :theme-data theme-data
                                   :default-color (:dark-gray (:themes default-values))}))
      (let [country-code (r/atom (:form-filling/country-code form-data))
            default-value (r/atom (get-default-text-val {:input-data input-data :field-id field-id :default-value default-value
                                                         :current-page @current-page :index index :num-scale-initial? false}))]
        (update-preview-panel! {:input-data input-data :field-id field-id
                                :value-to-update @default-value
                                :condition (not (s/blank? @default-value))})
        (add-watch phone-number :watcher
                   (fn []
                     (set-values-for-button! {:input-value input-value :component-input-value phone-number
                                              :field-id field-id :type (:type field)})))
        (check-button-status {:component-button-disabled? phone-num-button-disabled? :field-id field-id
                              :button-ids-for-button button-ids-for-button})
        [v-box
         :width "100%"
         :align (component-alignment is-multi-question?)
         :justify :center
         :children [[:div {:class
                           (responsive-input-field-style {:input-font-color (color-condition {:valid? @phone-valid?
                                                                                              :on-focus false
                                                                                              :theme-data nil
                                                                                              :default-color (:light-gray (:themes default-values))})
                                                          :title-field-color (color-condition {:valid? @phone-valid?
                                                                                               :on-focus @on-focus
                                                                                               :theme-data theme-data
                                                                                               :default-color (:dark-gray (:themes default-values))
                                                                                               :is-label? true})
                                                          :border-color (color-condition {:valid? @phone-valid?
                                                                                          :on-focus @on-focus
                                                                                          :theme-data theme-data
                                                                                          :default-color (:dark-gray (:themes default-values))})})}
                     (phone-number-input-label {:phone-number phone-number :default-value default-value :country-code country-code
                                                :phone-valid? phone-valid? :on-focus on-focus :theme-data theme-data
                                                :phone-num-button-disabled? phone-num-button-disabled?})]
                    [:div {:class (warning-notification {:width "350px"
                                                         :color (:error-mesage (:themes default-values))})}
                     (calc-error-message {:valid? phone-valid? :type "phone_number"
                                          :field field :form-messages form-messages})]]]))))